export default function getBaseUrl() {
  if (window.location?.hostname === "localhost") {
    const urlParams = new URLSearchParams(window.location.search || (window.location.hash.includes("?") ? window.location.hash.substring(window.location.hash.indexOf("?")) : ""));
    const paramSub = urlParams.get("subdomain");
    let subDomain = "admin";
    if (paramSub) {
      localStorage.setItem("dev_subdomain", paramSub);
      subDomain = paramSub;
    } else {
      subDomain = localStorage.getItem("dev_subdomain") || "admin";
    }
    return { subDomain, baseUrl: "https://api.themedius.ai" };
  }
  const host = window.location.host;
  const hostSplitArr = host.split(".");
  if (hostSplitArr[0] === "dev") return { subDomain: hostSplitArr[1], baseUrl: "https://dev.api.themedius.ai" };

  return { subDomain: hostSplitArr[0], baseUrl: "https://api.themedius.ai" };
}
